// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {}

.advance-search-work-order-modal .modal-dialog {
    max-width: 70%;
    margin-top: 3%;
}

.advance-search-work-order-modal .modal-dialog .modal-content {
    min-height: 30vh;
    padding: 0 51px;
}

.advance-search-work-order-modal .modal-dialog .wrapper-modal-header {
    width: 100%;
    padding: 60px 0;
    padding-bottom: 12px;
    border-bottom: 1px solid var(--neutral-color4);
}

.advance-search-work-order-modal .modal-header-title-section {
    display: flex;
    width: 100%;
    align-items: center;
}

.advance-search-work-order-modal .modal-header-title-section svg {
    margin-left: 10px;
}

.modal-header-title-section .modal-title {
    font: normal normal bold 28px/34px Lato;
    letter-spacing: 0.28px;
    color: var(--neutral-color7);
}

.advance-search-work-order-modal .modal-header-title-section span {
    margin-left: 15px;
    font: normal normal 300 28px/34px Lato;
    letter-spacing: 0.28px;
    color: var(--neutral-color5);
}

.advance-search-work-order-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font: normal normal bold 14px/19px Lato;
    letter-spacing: 0.14px;
    color: var(--text-color2);
}

.advance-search-work-order-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control span {
    margin-right: 10px;
}

.advance-search-work-order-modal .modal-body {
    max-height: 600px;
    padding-top: 20px;
    /* overflow-x: hidden; */
}

.modal-body .wrapper-modal-body {
    width: 100%;
    height: 100%;
    display: grid;
    grid-row-gap: 15px;
}

#workOrderAdvanceSearch .modal-body,
#trackOrderAdvanceSearch .modal-body,
#viewWorkOrderReportAdvanceSearch .modal-body{
    overflow-y: initial;
}
.advance-search-work-order-modal .wrapper-modal-body .mobal-body-section-group:nth-child(1){
    display: grid;
    grid-row-gap: 15px;
}
.advance-search-work-order-modal .wrapper-modal-body .mobal-body-section-group:nth-child(3) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 12px;
}

.advance-search-work-order-modal .wrapper-modal-body .mobal-body-section-group:last-child .card-item-group {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 30px;
    row-gap: 20px;
}
.advance-search-work-order-modal .modal-dialog .modal-content .modal-body .input-group-append .input-group-append-date-picker-section .react-date-picker__calendar{
    z-index: 2;
}

/* --------- Mobile Design ----------- */
@media screen and (max-width:992px) {
    .advance-search-work-order-modal .modal-dialog .modal-content {
        padding: 0 21px 20px 21px;
    }

    .advance-search-work-order-modal .wrapper-modal-body .mobal-body-section-group:nth-child(3) {
        grid-template-columns: 1fr;
        grid-template-rows: repeat(2, 1fr);
        grid-row-gap: 18px;
        margin-bottom: 10px;
    }
    .advance-search-work-order-modal .wrapper-modal-body .mobal-body-section-group:last-child .card-item-group{
        display: grid;
        grid-gap: 10px;
        grid-template-columns: 1fr;
        grid-row-gap: 25px;
        padding: 0 10px;
    }  
    .advance-search-work-order-modal .wrapper-modal-body .mobal-body-section-group:last-child .card-item-group .custom-checkbox{
        text-align: start;
    }
    .advance-search-work-order-modal .modal-body{
        max-height: 100%;
    }

    .advance-search-work-order-modal .search-btn-section{
        min-width: var(--refresh-btn-width);
        height: var(--refresh-btn-height);
    }
    .advance-search-work-order-modal .modal-dialog .modal-content .modal-body .input-group-append .input-group-append-date-picker-section .react-date-picker__calendar{
        right: 23px !important;
    }
    .advance-search-work-order-modal .modal-dialog .modal-content{
        height: auto;
        position: absolute;
        bottom: 0;
    }
    .advance-search-work-order-modal .search-btn-section svg{
        margin-right: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Assets/CSS/WorkOrderAdvanceSearchModal.css"],"names":[],"mappings":"AAAA,OAAO;;AAEP;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,oBAAoB;IACpB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uCAAuC;IACvC,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,sCAAsC;IACtC,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,uCAAuC;IACvC,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;;;IAGI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,qCAAqC;IACrC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,UAAU;AACd;;AAEA,wCAAwC;AACxC;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,0BAA0B;QAC1B,kCAAkC;QAClC,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,aAAa;QACb,cAAc;QACd,0BAA0B;QAC1B,kBAAkB;QAClB,eAAe;IACnB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,gBAAgB;IACpB;;IAEA;QACI,mCAAmC;QACnC,iCAAiC;IACrC;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,YAAY;QACZ,kBAAkB;QAClB,SAAS;IACb;IACA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[":root {}\r\n\r\n.advance-search-work-order-modal .modal-dialog {\r\n    max-width: 70%;\r\n    margin-top: 3%;\r\n}\r\n\r\n.advance-search-work-order-modal .modal-dialog .modal-content {\r\n    min-height: 30vh;\r\n    padding: 0 51px;\r\n}\r\n\r\n.advance-search-work-order-modal .modal-dialog .wrapper-modal-header {\r\n    width: 100%;\r\n    padding: 60px 0;\r\n    padding-bottom: 12px;\r\n    border-bottom: 1px solid var(--neutral-color4);\r\n}\r\n\r\n.advance-search-work-order-modal .modal-header-title-section {\r\n    display: flex;\r\n    width: 100%;\r\n    align-items: center;\r\n}\r\n\r\n.advance-search-work-order-modal .modal-header-title-section svg {\r\n    margin-left: 10px;\r\n}\r\n\r\n.modal-header-title-section .modal-title {\r\n    font: normal normal bold 28px/34px Lato;\r\n    letter-spacing: 0.28px;\r\n    color: var(--neutral-color7);\r\n}\r\n\r\n.advance-search-work-order-modal .modal-header-title-section span {\r\n    margin-left: 15px;\r\n    font: normal normal 300 28px/34px Lato;\r\n    letter-spacing: 0.28px;\r\n    color: var(--neutral-color5);\r\n}\r\n\r\n.advance-search-work-order-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    font: normal normal bold 14px/19px Lato;\r\n    letter-spacing: 0.14px;\r\n    color: var(--text-color2);\r\n}\r\n\r\n.advance-search-work-order-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control span {\r\n    margin-right: 10px;\r\n}\r\n\r\n.advance-search-work-order-modal .modal-body {\r\n    max-height: 600px;\r\n    padding-top: 20px;\r\n    /* overflow-x: hidden; */\r\n}\r\n\r\n.modal-body .wrapper-modal-body {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: grid;\r\n    grid-row-gap: 15px;\r\n}\r\n\r\n#workOrderAdvanceSearch .modal-body,\r\n#trackOrderAdvanceSearch .modal-body,\r\n#viewWorkOrderReportAdvanceSearch .modal-body{\r\n    overflow-y: initial;\r\n}\r\n.advance-search-work-order-modal .wrapper-modal-body .mobal-body-section-group:nth-child(1){\r\n    display: grid;\r\n    grid-row-gap: 15px;\r\n}\r\n.advance-search-work-order-modal .wrapper-modal-body .mobal-body-section-group:nth-child(3) {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr);\r\n    grid-column-gap: 12px;\r\n}\r\n\r\n.advance-search-work-order-modal .wrapper-modal-body .mobal-body-section-group:last-child .card-item-group {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, 1fr);\r\n    column-gap: 30px;\r\n    row-gap: 20px;\r\n}\r\n.advance-search-work-order-modal .modal-dialog .modal-content .modal-body .input-group-append .input-group-append-date-picker-section .react-date-picker__calendar{\r\n    z-index: 2;\r\n}\r\n\r\n/* --------- Mobile Design ----------- */\r\n@media screen and (max-width:992px) {\r\n    .advance-search-work-order-modal .modal-dialog .modal-content {\r\n        padding: 0 21px 20px 21px;\r\n    }\r\n\r\n    .advance-search-work-order-modal .wrapper-modal-body .mobal-body-section-group:nth-child(3) {\r\n        grid-template-columns: 1fr;\r\n        grid-template-rows: repeat(2, 1fr);\r\n        grid-row-gap: 18px;\r\n        margin-bottom: 10px;\r\n    }\r\n    .advance-search-work-order-modal .wrapper-modal-body .mobal-body-section-group:last-child .card-item-group{\r\n        display: grid;\r\n        grid-gap: 10px;\r\n        grid-template-columns: 1fr;\r\n        grid-row-gap: 25px;\r\n        padding: 0 10px;\r\n    }  \r\n    .advance-search-work-order-modal .wrapper-modal-body .mobal-body-section-group:last-child .card-item-group .custom-checkbox{\r\n        text-align: start;\r\n    }\r\n    .advance-search-work-order-modal .modal-body{\r\n        max-height: 100%;\r\n    }\r\n\r\n    .advance-search-work-order-modal .search-btn-section{\r\n        min-width: var(--refresh-btn-width);\r\n        height: var(--refresh-btn-height);\r\n    }\r\n    .advance-search-work-order-modal .modal-dialog .modal-content .modal-body .input-group-append .input-group-append-date-picker-section .react-date-picker__calendar{\r\n        right: 23px !important;\r\n    }\r\n    .advance-search-work-order-modal .modal-dialog .modal-content{\r\n        height: auto;\r\n        position: absolute;\r\n        bottom: 0;\r\n    }\r\n    .advance-search-work-order-modal .search-btn-section svg{\r\n        margin-right: 10px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
